import { formatTableOrdinalLabel } from "@/lib/mappingRegions";
import { isInternalRegionLabel } from "@/lib/regionSheetLabels";

interface PipelineMultiTableDqxChromeProps {
  tableIndex: number;
  tableCount: number;
  /** Confirm Structure label: Table N or Table N - SheetName. */
  sheetLabel?: string | null;
  onPreviousTable: () => void;
  onNextTable: () => void;
}

export function PipelineMultiTableDqxChrome({
  tableIndex,
  tableCount,
  sheetLabel,
  onPreviousTable,
  onNextTable,
}: PipelineMultiTableDqxChromeProps) {
  if (tableCount <= 1) return null;

  const hasPrevious = tableIndex > 0;
  const hasNext = tableIndex < tableCount - 1;
  const trimmedLabel = sheetLabel?.trim() || "";
  const title =
    trimmedLabel && !isInternalRegionLabel(trimmedLabel)
      ? trimmedLabel
      : formatTableOrdinalLabel(tableIndex + 1);

  return (
    <div className="sticky top-0 z-30 flex flex-wrap items-center justify-between gap-3 border-b border-[var(--color-border-light)] bg-white/95 px-6 py-3 backdrop-blur-sm">
      <div>
        <p className="text-sm font-medium text-[var(--color-text-primary)]">{title}</p>
      </div>
      <div className="flex items-center gap-2">
        {hasPrevious ? (
          <button
            type="button"
            onClick={onPreviousTable}
            className="rounded-md border border-[var(--color-border-light)] bg-white px-3 py-1.5 text-sm font-medium text-[var(--color-text-primary)] hover:bg-[var(--color-bg-secondary)]"
          >
            Previous table
          </button>
        ) : null}
        {hasNext ? (
          <button
            type="button"
            onClick={onNextTable}
            className="rounded-md bg-[var(--color-brand-primary)] px-3 py-1.5 text-sm font-medium text-white hover:opacity-90"
          >
            Next table
          </button>
        ) : null}
      </div>
    </div>
  );
}
